var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8DataBackup50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 9,
    x: 7,
    y: 33,
    fill: "#7debf5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 5,
    x: 10,
    y: 28,
    fill: "#00b3d7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 9,
    x: 7,
    y: 6,
    fill: "#7debf5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 9,
    x: 7,
    y: 19,
    fill: "#7debf5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 4,
    x: 10,
    y: 15,
    fill: "#00b3d7"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 3,
    x: 10,
    y: 19,
    fill: "#3dd9eb"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 3,
    x: 10,
    y: 33,
    fill: "#3dd9eb"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6c19ff",
    d: "M37.5,27c-4.5,0-8.3,2.8-9.8,6.8h4.5c1.2-1.7,3.1-2.8,5.3-2.8c3.6,0,6.5,2.9,6.5,6.5S41.1,44,37.5,44 c-1.8,0-3.5-0.8-4.7-2H28c1.7,3.5,5.3,6,9.5,6C43.3,48,48,43.3,48,37.5S43.3,27,37.5,27z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#6c19ff",
    points: "29,38.6 34.4,34 26.4,31.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8DataBackup50);
export default __webpack_public_path__ + "static/media/icons8-data-backup-50.75c9d1551bb2432fdb93b7cb6262940d.svg";
export { ForwardRef as ReactComponent };